const pynycode = require('punycode/')

export function usePunycodeToUnicode(string) {
    try {
        return pynycode.toUnicode(string)
    } catch (ignored) {}
    return string
}